import { atom, selector } from "recoil";

import { SORT_VALUE } from "components/Shop/constants";
import { ConsultationSessionType, GetActiveProductsQuery } from "graphql/generated";
import { checkIsCountryHaveTextConsult } from "src/utils";

import { cartItemsState, platformState } from ".";
import keys from "./constants";

export const selectedCategoryState = atom<string>({
  key: keys.SELECTED_CATEGORY_STATE,
  default: "all"
});

export const productsState = atom<any>({
  key: keys.PRODUCTS_STATE,
  default: []
});

export const productSearchValueState = atom<string>({
  key: keys.PRODUCT_SEARCH_VALUE_STATE,
  default: ""
});

export const productSortValueState = atom<string>({
  key: keys.PRODUCT_SORT_VALUE_STATE,
  default: SORT_VALUE.CONDITIONS
});

export const isDetailModalOpenedState = atom<boolean>({
  key: keys.IS_DETAIL_MODAL_OPENED_STATE,
  default: false
});

export const isPriceModalOpenedState = atom<boolean>({
  key: keys.IS_PRICE_MODAL_OPENED_STATE,
  default: false
});

export const selectedConsultTypeState = atom<ConsultationSessionType>({
  key: keys.SELECTED_CONSULT_TYPE_STATE,
  default: checkIsCountryHaveTextConsult()
    ? ConsultationSessionType.Text
    : ConsultationSessionType.Video
});

export const isAddingCartState = atom<boolean>({
  key: keys.IS_ADDING_CART_STATE,
  default: false
});

export const priceModalSelectedProductState = atom<any>({
  key: keys.PRICE_MODAL_SELECTED_PRODUCT_STATE,
  default: null
});

// price modal includes 2 step: product and price selections
export const priceModalShowPriceStep = atom<boolean>({
  key: keys.PRICE_MODAL_STEP,
  default: !checkIsCountryHaveTextConsult()
});

export const priceModalSelectedPriceState = atom<any>({
  key: keys.PRICE_MODAL_SELECTED_PRICE_STATE,
  default: null
});

export const productDetailState = atom<any>({
  key: keys.PRODUCT_DETAIL_STATE,
  default: null
});

export const noMatchedState = atom<boolean>({
  key: keys.NO_MATCHED_STATE,
  default: false
});

export type ActiveProductInfo = GetActiveProductsQuery["getActiveProducts"];
export const activeProductsState = atom<ActiveProductInfo>({
  key: keys.ACTIVE_PRODUCTS_STATE,
  default: {
    activeProducts: [],
    completedEvalIds: [],
    pendingEvalIds: [],
    skippedEvalIds: []
  }
});

export const isFetchingActiveProductsState = atom<boolean>({
  key: keys.IS_FETCHING_ACTIVE_PRODUCTS_STATE,
  default: true
});

export const pendingEvalIdsState = selector<string[]>({
  key: keys.PENDING_EVALS_STATE,
  get: ({ get }) => {
    const { pendingEvalIds } = get(activeProductsState);
    const cartItems = get(cartItemsState);
    const platform = get(platformState);

    const cartEvalIds = cartItems
      .map((item) => item?.product?.evaluationId?.[platform] ?? "")
      .filter((evalId) => evalId !== "");

    return [...pendingEvalIds, ...cartEvalIds] ?? [];
  }
});
